import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { OrgAPI } from "pages/organization/org.service";
const initialState = {
  data: [],
  state: ""
};
export const designationsSlice = createSlice({
  name: "designations",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getDesignations.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getDesignations.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getDesignations = createAsyncThunk('designations/get', async(query) => {
  
  let data = await OrgAPI.getOrgDesignations();
  return data['designations'];

});


export default designationsSlice.reducer;